module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/high-capacity-transport-cancel.f1471f03.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/high-capacity-transport-cancel.png
// module id = 3737
// module chunks = 11